import { MasterDataService } from 'src/app/services/master-data.service';
import { Component, OnInit } from '@angular/core';
import { CommonMessageService } from 'src/app/services/common-message.service';

@Component({
  selector: 'app-my-salary-closing',
  templateUrl: './my-salary-closing.component.html',
  styleUrls: ['./my-salary-closing.component.css'],
})
export class MySalaryClosingComponent implements OnInit {
  selectedFinancialYear;
  financialList;
  closingDateList;
  selectedClosing;
  reportList = null;
  userId;
  constructor(private masterDataService: MasterDataService, private commonMessageService:CommonMessageService) {}

  ngOnInit(): void {
    this.selectedFinancialYear = '';
    this.selectedClosing = '';
    this.loadFinancialDetails();
  }

  loadFinancialDetails() {
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
  }

  onFinancialYearSlected() {
    this.selectedClosing = '';
    if (
      this.selectedFinancialYear != null &&
      this.selectedFinancialYear != undefined &&
      this.selectedFinancialYear != ''
    ) {
      this.masterDataService
        .getClosingDatesByFinancialYear(this.selectedFinancialYear.id)
        .subscribe((res) => {
          this.closingDateList = res;
        });
    }
  }

  showExportToExcelButton=false;
  onViewReport() {
    if (
      this.selectedClosing == null ||
      this.selectedClosing == '' ||
      this.selectedClosing == undefined ||
      this.selectedFinancialYear == '' ||
      this.selectedFinancialYear == null ||
      this.selectedFinancialYear == undefined
    ) {
      this.commonMessageService.swalAlertWithoutIcon('','Please choose all the values');
      return;
    }
    this.userId = localStorage.getItem('id');
    console.log('userId', this.userId);
    this.masterDataService
      .getSalaryReport(0, this.selectedClosing, 0, 0, this.userId)
      .subscribe((res) => {
        this.reportList = res;
        if (this.reportList.length == 0) {
          this.showExportToExcelButton=false;
          this.commonMessageService.swalAlertWithoutIcon('','No record found')
        }else{
          this.showExportToExcelButton=true;
        }
      });
  }


  exportToExcelClick(){
    this.userId = localStorage.getItem('id');
    this.masterDataService
    .getSalaryReportExportToExcel(0, this.selectedClosing, 0, 0, this.userId)
    .subscribe((resp:any) => {
      const blob = new Blob([resp]); // you can change the type
      var downloadURL= window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "MySalaryClosingReport.xlsx";
      link.click();
    });
  }
}
